//useFirestore.js
import { db } from "@/firebase/init";
import { doc, getDoc, updateDoc, deleteDoc, setDoc} from "firebase/firestore";
import {usersCollection, globalSettingsCollection, defaultGlobalSettings} from './useGlobalVariables'
//import { getCountFromServer } from "firebase/firestore";


/**
 * Fetch user profile from Firestore
 */
export const getUserProfile = async (uid) => {
  console.log(`[Database Fetch] Getting user profile for uid: ${uid}`);
  const userDoc = await getDoc(doc(db, usersCollection, uid));
  console.log(`[Database Fetch] User profile fetch complete: ${userDoc.exists() ? 'found' : 'not found'}`);
  return userDoc.exists() ? userDoc.data() : null;
};

/**
 * Create or update user profile in Firestore
 */
export const updateUserProfile = async (uid, updates) => {
  const userRef = doc(db, usersCollection, uid);
  await updateDoc(userRef, updates);
};

/**
 * Delete user profile from Firestore
 */
export const deleteUserProfile = async (uid) => {
  await deleteDoc(doc(db, usersCollection, uid));
};


/**
 * Fetch global settings from Firestore or create them if missing
 */
export const getGlobalSettings = async () => {
  try {
    console.log('[Database Fetch] Getting global settings');
    const settingsRef = doc(db, globalSettingsCollection, "globalSettings");
    const settingsDoc = await getDoc(settingsRef);

    if (settingsDoc.exists()) {
      console.log('[Database Fetch] Global settings found in database');
      return settingsDoc.data();
    } else {
      // If document does not exist, create it with default values
      console.log('[Database Fetch] Global settings not found, creating default settings');
      await setDoc(settingsRef, defaultGlobalSettings);
      console.log("Global settings document created with default values.");
      return defaultGlobalSettings;
    }
  } catch (error) {
    console.error("Error fetching or creating global settings:", error);
    return null;
  }
};

/**
 * Update global settings in Firestore
 */
export const updateGlobalSettings = async (updates) => {
  try {
    const settingsRef = doc(db, globalSettingsCollection, "globalSettings");
    await updateDoc(settingsRef, updates);
    return { success: true, message: "Global settings updated successfully." };
  } catch (error) {
    console.error("Error updating global settings:", error);
    return { success: false, message: error.message };
  }
};




